import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { configureAmplify } from '@/config/amplify';
import { App } from '@/App';
import '@/styles/index.css';

configureAmplify();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
